// extracted by mini-css-extract-plugin
export default {"searchSuggestionInput":"SearchSuggestionInput_searchSuggestionInput__0OM-I","itemList":"SearchSuggestionInput_itemList__sx-pQ","item":"SearchSuggestionInput_item__M3Rle"};